export interface UserSettings {
    userId: string;
    recordViewsFoldersExpanded: boolean;
    settings: { [key: string]: any };
}

export const UserSettingsKeys = {
	DarkMode: "darkMode"
}
